import { useState } from 'react';

import _ from 'lodash';

import { useRouter } from 'next/router';

import PropTypes from 'prop-types';

import { IconButton, Button } from '@mui/material';

import MailOutlineIcon from '@mui/icons-material/MailOutline';

import {
    FacebookShareButton,
    WhatsappShareButton,
    TelegramShareButton,
    TwitterShareButton,
    FacebookIcon,
    WhatsappIcon,
    TelegramIcon,
    TwitterIcon,
} from 'next-share';

import { Label, Image, Popup } from '../../shared';

import useResponsive from '../../../../utils/responsive';

const RoomTypeHeader = (props) => {

    const { selectedRoomType, buildings, cities, selectedRoomPortfolio } = props;

    const { isMobile, isTablet, isClient } = useResponsive();

    const [popupVisible, setPopupVisible] = useState(false);

    const router = useRouter();

    const roomDescription = _.get(selectedRoomType, 'description');
    const maxGuests = _.get(selectedRoomType, 'maxGuests');
    const buildingName = _.get(selectedRoomType, 'buildingName');
    const addressLine1 = _.get(selectedRoomType, 'buildingAddress.addressLine1');
    const addressLine2 = _.get(selectedRoomType, 'buildingAddress.addressLine2');
    const numberAvailable = _.get(selectedRoomType, 'numberAvailable');
    const gender = _.get(router, 'query.gender');
    const url = isClient ? window.location.href : null;
    const buildingId = _.get(selectedRoomType, 'buildingId');
    const labelText = numberAvailable > 0 ? `only ${numberAvailable} left` : 'Waiting List';
    const labelType = numberAvailable > 0 ? '' : 'green';

    const building = _.find(buildings, { id: buildingId });
    const buildingCity = _.find(cities, { id: _.get(building, 'address.cityId') });
    const cityName = _.get(buildingCity, 'name');
    const portfolioHasLogo = _.get(selectedRoomPortfolio, 'images[0]') ? true : false;

    let arrangementType;
    if (_.get(selectedRoomType, 'privateBedroom')) {
        if (_.get(selectedRoomType, 'sharedLivingSpace')) {
            arrangementType = 'Private Room';
        } else if (!_.get(selectedRoomType, 'sharedLivingSpace')) {
            arrangementType = 'Private Apartment';
        }
    } else if (!_.get(selectedRoomType, 'privateBedroom')) {
        arrangementType = `Shared - ${gender}`;
    }

    let livingArrangement = _.get(selectedRoomType, 'privateBedroom')
        ? 'Private'
        : 'Shared living space with shared bedroom';
    if (_.get(selectedRoomType, 'privateBedroom')) {
        livingArrangement = _.get(selectedRoomType, 'sharedLivingSpace')
            ? 'Shared living space with private bedroom'
            : 'Private apartment';
    }

    let fullAddddress = `${buildingName}, ${addressLine1}, ${addressLine2}, ${cityName}`;
    if (!addressLine2) {
        fullAddddress = `${buildingName}, ${addressLine1}, ${cityName}`;
    }

    const onShareClick = () => {
        setPopupVisible(true);
    };

    const onPopupClose = () => {
        setPopupVisible(false);
    };

    const Mailto = ({ email, subject = '', body = '', children }) => {
        let params = subject || body ? '?' : '';
        if (subject) params += `subject=${encodeURIComponent(subject)}`;
        if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

        return <a href={`mailto:${email}${params}`}>{children}</a>;
    };

    const selectedRoomPortfolioLogo =
        _.get(selectedRoomPortfolio, 'name') === 'HOMii'
            ? '/assets/images/homii_logo.png'
            : _.get(selectedRoomPortfolio, 'images[0]');
    const selectedRoomPortfolioLogoHeight =
        _.get(selectedRoomPortfolio, 'name') === 'HOMii' ? 13 : 20;

    return (
        <>
            <div className='room-type-header-label-container'>
                {numberAvailable <= 2 && (
                    <span className='room-type-header-label-wrapper'>
                        <Label type={labelType} id="number_available_label">
                            {labelText}
                        </Label>
                    </span>
                )}
                <Label type="white" id="arrangement_type_label">
                    {arrangementType}
                </Label>
            </div>

            <div className='room-type-header-row'>

                <h3 className='room-type-header-header3' id="room_header">{roomDescription}</h3>

                {!isMobile && (
                    <div className='room-type-header-managed-container'>

                        <p className='room-type-header-description'>
                            Managed by{' '}
                            <strong>
                                {!portfolioHasLogo && _.get(selectedRoomPortfolio, 'name')}
                            </strong>
                        </p>

                        {portfolioHasLogo && (
                            <Image
                                className='room-type-header-logo'
                                id="portfolio_logo"
                                src={selectedRoomPortfolioLogo}
                                alt="portfolio logo"
                                height={selectedRoomPortfolioLogoHeight}
                                isOldImage
                            />
                        )}

                    </div>
                )}

                {isMobile && (
                    <div className='room-type-header-button-container'>
                        <IconButton id="share-button" aria-label="share" onClick={onShareClick}>
                            <Image
                                src="/assets/images/share.png"
                                alt="share-button"
                                isOldImage
                                height={15}
                            />
                        </IconButton>
                    </div>
                )}

            </div>

            <p className='room-type-header-address'>{fullAddddress}</p>

            <div className='room-type-header-row'>

                <p className='room-type-header-description'>
                    {livingArrangement} • Sleeps {maxGuests}
                </p>

                {!isMobile && (
                    <div>
                        <Button
                            className='room-type-header-button'
                            id="share-button"
                            onClick={onShareClick}
                            aria-label="share"
                            size="large"
                            endIcon={
                                <Image
                                    src="/assets/images/share.png"
                                    alt="share-button"
                                    height={15}
                                    isOldImage
                                />
                            }
                        >
                            Share
                        </Button>
                    </div>
                )}
            </div>

            {isMobile && (
                <div className='room-type-header-row'>

                    <p className='room-type-header-description'>
                        Managed by{' '}
                        <strong>{!portfolioHasLogo && _.get(selectedRoomPortfolio, 'name')}</strong>
                    </p>

                    {portfolioHasLogo && (
                        <Image
                            className='room-type-header-logo'
                            id="portfolio_logo"
                            src={_.get(selectedRoomPortfolio, 'images[0]')}
                            alt="portfolio logo"
                            height={20}
                            isOldImage
                        />
                    )}

                </div>
            )}

            <Popup isOpen={popupVisible} onClose={onPopupClose}>

                <div className='room-type-header-content-container'>

                    <Image
                        src={_.get(selectedRoomType, 'images[0]')}
                        alt={roomDescription}
                        className="room-type-header-image card-image"
                        isOldImage
                    />

                    <div className='room-type-header-text-container'>

                        <h6>Share this room</h6>

                        <h4 className='room-type-header-header4'>{roomDescription}</h4>

                        <p className='room-type-header-paragraph'>{fullAddddress}</p>

                        <div className='room-type-header-buttons-container'>

                            <FacebookShareButton
                                url={url}
                                quote={`HOMii - ${roomDescription}`}
                                hashtag="#HOMii"
                                className="share-icons"
                            >
                                <FacebookIcon size={36} borderRadius={5} />
                            </FacebookShareButton>

                            <TwitterShareButton
                                title={`HOMii - ${roomDescription}`}
                                url={url}
                                via="Homii_Living"
                                hashtag="#homiilifestyle"
                                className="share-icons"
                            >
                                <TwitterIcon size={36} borderRadius={5} />
                            </TwitterShareButton>

                            <WhatsappShareButton
                                url={url}
                                title={`HOMii - ${roomDescription}`}
                                separator=": "
                                className="share-icons"
                            >
                                <WhatsappIcon size={36} borderRadius={5} />
                            </WhatsappShareButton>

                            <TelegramShareButton
                                url={url}
                                title={`HOMii - ${roomDescription}`}
                                className="share-icons"
                            >
                                <TelegramIcon size={36} borderRadius={5} />
                            </TelegramShareButton>

                            <Mailto email="" subject={`HOMii - ${roomDescription}`} body={url}>
                                <div className='room-type-header-mail-icon-container'>
                                    <MailOutlineIcon className='room-type-header-mail-icon' />
                                </div>
                            </Mailto>

                        </div>

                    </div>

                </div>

            </Popup>
        </>
    );
};

export default RoomTypeHeader;

RoomTypeHeader.propTypes = {
    selectedRoomType: PropTypes.object,
    buildings: PropTypes.object,
    cities: PropTypes.object,
    baseUrlApp: PropTypes.string,
    email: PropTypes.string,
    subject: PropTypes.string,
    body: PropTypes.string,
    children: PropTypes.node,
    selectedRoomPortfolio: PropTypes.object,
};
